import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { FooterLink, FooterText } from './FormComponents';
export default function TermsAndPrivacyMessage(param) {
    let { type } = param;
    const { t: termsAndPrivacyTexts } = useLocaleKeys('pages.auth.termsAndPrivacy');
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ _jsxs(FooterText, {
                children: [
                    type === 'login' ? termsAndPrivacyTexts.bySigningIn() : termsAndPrivacyTexts.bySigningUp(),
                    ' '
                ]
            }),
            /*#__PURE__*/ _jsx(FooterLink, {
                toExternalLink: "https://www.sayanchor.com/terms-of-contact",
                target: "_blank",
                children: termsAndPrivacyTexts.termsOfService()
            }),
            /*#__PURE__*/ _jsxs(FooterText, {
                children: [
                    " ",
                    termsAndPrivacyTexts.and(),
                    " "
                ]
            }),
            /*#__PURE__*/ _jsx(FooterLink, {
                toExternalLink: "https://www.sayanchor.com/privacy-policy",
                target: "_blank",
                children: termsAndPrivacyTexts.privacyPolicy()
            }),
            /*#__PURE__*/ _jsx(FooterText, {
                children: "."
            })
        ]
    });
}
